<script setup lang="ts">
import { useConfirm, VIcons } from '@/shared/ui'
import type { PropType } from 'vue'
import type { AdminConfiguratorType } from '@/entities/Cabinet'
import { useTranslate } from '@/shared/lib'
import { useRoute } from 'vue-router'
import { useConfiguratorDelete } from './../model/api'

const props = defineProps({
  item: {
    type: Object as PropType<AdminConfiguratorType>,
    required: true,
  },
})

const { show } = useConfirm()
const { trs } = useTranslate()
const route = useRoute()
const emits = defineEmits(['updated'])

const { remove, isPending } = useConfiguratorDelete(props.item.id, Number(route.params.object_id))

/**
 * Обработка удаления конфигурации
 */
const clickHandler = () => {
  show({
    confirmFunc: async () => {
      await remove()
      emits('updated')
    },
    title: trs('itf.config_remove'),
  })
}
</script>

<template>
  <VTooltip location="top" :open-delay="500" :text="$t('itf.delete')">
    <template #activator="{ props: tooltipProps }">
      <VBtn
        icon
        density="compact"
        color="error"
        :loading="isPending"
        v-bind="tooltipProps"
        @click="clickHandler"
      >
        <VIcons type="delete" />
      </VBtn>
    </template>
  </VTooltip>
</template>
